import type { FBSContainerListResponse } from "@/shared/generated/ExpHubApi";

export type UsageForecastItem = {
  month: number;
  usage: number;
};

export const mapToUsageForecastItemType = (
  data: NonNullable<
    FBSContainerListResponse["containers"][number]["usageForecast"]
  >[number],
): UsageForecastItem => {
  return {
    month: data.month,
    usage: data.usage,
  };
};
